import type { InventoryItem } from '@/modules/inventory/types';
import type { CalendarEvent, CalendarEventFilters } from '@/modules/calendar/types';
import type { Reservation } from '@/modules/reservations/types';

export function filterReservationsForCalendar(
  reservations: Reservation[],
  filters: CalendarEventFilters,
  itemsById: Map<string, InventoryItem>,
): Reservation[] {
  let result = reservations;

  if (filters.status && filters.status !== 'all') {
    result = result.filter((r) => r.status === filters.status);
  }

  if (filters.itemId) {
    result = result.filter((r) =>
      r.inventoryItemIds.includes(filters.itemId!),
    );
  }

  if (filters.categoryId) {
    result = result.filter((r) =>
      r.inventoryItemIds.some((itemId) => {
        const item = itemsById.get(itemId);
        return item?.categoryId === filters.categoryId;
      }),
    );
  }

  return result;
}

export function filterCalendarEvents(
  events: CalendarEvent[],
  filters: CalendarEventFilters,
  itemsById: Map<string, InventoryItem>,
): CalendarEvent[] {
  let result = events;

  if (filters.showReservations === false) {
    result = result.filter((e) => e.source !== 'reservation');
  }
  if (filters.showLogistics === false) {
    result = result.filter((e) => e.source !== 'logistics');
  }
  if (filters.status && filters.status !== 'all') {
    result = result.filter(
      (e) =>
        e.source === 'reservation' && e.reservationStatus === filters.status,
    );
  }
  if (filters.itemId) {
    result = result.filter((e) =>
      e.relatedInventoryItems.includes(filters.itemId!),
    );
  }
  if (filters.categoryId) {
    result = result.filter((e) =>
      e.relatedInventoryItems.some((itemId) => {
        const item = itemsById.get(itemId);
        return item?.categoryId === filters.categoryId;
      }),
    );
  }
  return result;
}

export function eventsForDay(
  events: CalendarEvent[],
  day: string,
): CalendarEvent[] {
  return events.filter((e) => day >= e.start && day <= e.end);
}
